import { Modal } from "@joonapp/web-shared"

import AddEditScheduledMessage from "./AddEditScheduledMessage"
import useScheduledMessageModalStore, {
  ScheduledMessageModalView,
} from "./useScheduledMessageModalStore"
import ViewScheduledMessage from "./ViewScheduledMessage"

const ScheduledMessageModal = () => {
  const { isOpen, onClose, view } = useScheduledMessageModalStore()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "min(600px, 95vw)" }}
    >
      {view === ScheduledMessageModalView.ADD ||
      view === ScheduledMessageModalView.EDIT ? (
        <AddEditScheduledMessage />
      ) : (
        <ViewScheduledMessage />
      )}
    </Modal>
  )
}

export default ScheduledMessageModal
